import { render } from "./Scope-Of-Work.vue?vue&type=template&id=5ad5e4c5"
import script from "./Scope-Of-Work.vue?vue&type=script&lang=js"
export * from "./Scope-Of-Work.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__